import React, { useEffect } from 'react';
import { translate } from '../../services/TranslationService';
import { withTranslation } from '../../shared/components/withTranslation';
import { withNOVOHeader } from '../sideMenu/HeaderHOC';
import MyCityDesktopLayout from './components/MyCityDesktopLayout';
import MyCityMobileLayout from './components/MyCityMobileLayout';
import { useMyCityData } from './hooks/useMyCityData';

const MyCity = ({ setHeaderTitle }) => {
  const myCityData = useMyCityData();

  useEffect(() => {
    setHeaderTitle?.(translate('sideMenu.MyCity'));
  }, [setHeaderTitle]);

  const LayoutComponent = myCityData.isMobileView
    ? MyCityMobileLayout
    : MyCityDesktopLayout;

  return <LayoutComponent {...myCityData} />;
};

export default withNOVOHeader(withTranslation(MyCity));
